<script setup>
import {onMounted} from "vue";

onMounted(() => {
  setTimeout(() => {
    window.location.href = "https://www.rivconnect.fr";
  }, 10000);

});

</script>
